import { app } from '@/main'
import { priceFormat } from '@G/filters'

// 固定條件 中、英、數、特殊符號、大小寫區分
export const regex = {
  engNum: /^[A-Za-z0-9]+$/,
  engNumSymbol: /^[A-Za-z0-9~!@#$%^&*()-_+{}|:"<>?[\]\\;',./\s]+$/,
  chiEngNum: /^[\u4e00-\u9fa5A-Za-z0-9]+$/,
  chiEngNumSymbol: /^[\u4e00-\u9fa5A-Za-z0-9~!@#$%^&*()-_+{}|:"<>?[\]\\;',./\s：（）]+$/
}
const ruleRequired = field => {
  return {
    required: field !== '',
    message: () => app.$t('i18n_rule_required_fill', { field })
  }
}

const ruleRegex = (pattern, message) => {
  return {
    pattern: pattern,
    message: function() {
      return message
    }
  }
}

const ruleRange = (min, max, message) => {
  return {
    min,
    message: function() {
      return message
    }
  }
}

// 英數
export const engNum = (field = '', min = 0, max = 0) => {
  const rules = []
  const regexMessage = !min
    ? app.$t('i18n_rule_alpjanumeric')
    : app.$t('i18n_rule_range_alphanumeric', { min, max })

  field !== '' && rules.push(ruleRequired(field))
  rules.push(ruleRegex(regex.engNum, regexMessage))
  min && rules.push(ruleRange(min, max, regexMessage))

  return { rules }
}
//英數 符號
export const engNumSymbol = (field = '', min = 0, max = 0) => {
  const rules = []
  const regexMessage = !min
    ? app.$t('i18n_rule_alpjanumeric_symbol')
    : app.$t('i18n_rule_range_alpjanumeric_symbol', { min, max })

  field !== '' && rules.push(ruleRequired(field))
  rules.push(ruleRegex(regex.engNum, regexMessage))
  min && rules.push(ruleRange(min, max, regexMessage))

  return { rules }
}
//中英數
// export const chiEngNum = (field = '', min = 0, max = 0) => {
//   const rules = []
//   field !== '' && rules.push(ruleRequired(field))
//   rules.push(ruleRegex(regex.chiEngNum))
//   min && rules.push(ruleRange(min, max))
//   return { rules }
// }
//中英數 符號
export const chiEngNumSymbol = (field = '', min = 0, max = 0) => {
  const rules = []
  field !== '' && rules.push(ruleRequired(field))
  rules.push(ruleRegex(regex.chiEngNumSymbol, app.$t('i18n_rule_all_char')))
  min && rules.push(ruleRange(min, max, app.$t('i18n_rule_all_char')))
  return { rules }
}
//英數 區分大小寫
export const engNumCase = (field = '', min = 0, max = 0) => {
  const rules = []
  const regexMessage = !min
    ? app.$t('i18n_rule_alpjanumeric_case')
    : app.$t('i18n_rule_range_alphanumeric_case', { min, max })

  field !== '' && rules.push(ruleRequired(field))
  rules.push(ruleRegex(regex.engNum, regexMessage))
  min && rules.push(ruleRange(min, max, regexMessage))

  return { rules }
}
//英數符號 區分大小寫
// export const engNumSymbolCase = (field = '', min = 0, max = 0) => {
//   const rules = []
//   field !== '' && rules.push(ruleRequired(field))
//   rules.push(ruleRegex(regex.engNumSymbol))
//   min && rules.push(ruleRange(min, max))
//   return { rules }
// }

//   field && rules.push(ruleRequired)
//   rules.push(ruleRegex)
//   min && rules.push(ruleRange)

//   return {
//     rules: rules
//   }
// }

/*
欄位檢核-帳號
支援：
1. 必填檢核
2. 英數檢核
3. 字數檢核，預設最大20/最小5
不支援：
1. 帳號是否已存在，需由 api 得知，自行處理
*/
export const account = engNum(app.$t('i18n_account'), 5, 20)

/*
  欄位檢核-密碼
  支援：
  1. 必填檢核
  2. 英數及特殊符號(含空格)檢核[常見符號：~!@#$%^&*()_+{}|:"<>?[]\;',./]
  3. 字數檢核，預設最大20/最小8
  不支援：
  1. 區分大小寫，需由 api 得知，自行處理
  */
export const password = (message = app.$t('i18n_password')) => {
  return engNumCase(message, 5, 20)
}

/*
  欄位檢核-姓名
  支援：
  1. 必填檢核
  2. 限輸入中英文數字, "-", "_"
  3. 字數檢核，預設30
  */
// export const fullName = (max = 30) => {
//   return {
//     validateFirst: true,
//     rules: [
//       {
//         required: true,
//         message: function() {
//           return app.$t('i18n_rule_required_fill', {
//             field: app.$t('i18n_username')
//           })
//         }
//       },
//       {
//         pattern: /^[\u4e00-\u9fa5A-Za-z0-9_-]+$/,
//         message: function() {
//           return app.$t('i18n_rule_no_symbol', {
//             target: app.$t('i18n_username')
//           })
//         }
//       },
//       {
//         max,
//         message: function() {
//           return app.$t('i18n_rule_no_exceed', {
//             max
//           })
//         }
//       }
//     ]
//   }
// }

//tryy 格式錯誤提示未包含特殊符號...待確認
/*
  欄位檢核-名稱
  支援：
  1. 必填檢核
  2. 中英數及特殊符號(含空格)檢核[常見符號：~!@#$%^&*()_+{}|:"<>?[]\;',./]
  3. 字數檢核，預設30
  */
// export const name = (max = 30, i18nString = 'i18n_role_name') => {
//   return {
//     validateFirst: true,
//     rules: [
//       {
//         required: true,
//         message: function() {
//           return app.$t('i18n_rule_required_fill', {
//             field: app.$t('i18n_name')
//           })
//         }
//       },
//       {
//         pattern: /^[\u4e00-\u9fa5A-Za-z0-9~!@#$%^&*()-_+{}|:"<>?[\]\\;',./\s]+$/,
//         message: function() {
//           return app.$t('i18n_rule_all_char')
//         }
//       }
//     ]
//   }
// }

/*
  欄位檢核-角色名稱
  支援：
  1. 必填檢核
  2. 限中英數
  3. 字數檢核，預設最小4/最大20
  */
// export const roleName = (min = 4, max = 20) => {
//   return {
//     validateFirst: true,
//     rules: [
//       {
//         required: true,
//         message: function() {
//           return app.$t('i18n_rule_required_fill', {
//             field: app.$t('i18n_role_name')
//           })
//         }
//       },
//       {
//         pattern: /^[\u4e00-\u9fa5A-Za-z0-9]+$/,
//         message: function() {
//           return app.$t('i18n_rule_cn_en_num_interval', {
//             target: app.$t('i18n_role_name'),
//             min,
//             max
//           })
//         }
//       },
//       {
//         min,
//         message: function() {
//           return app.$t('i18n_rule_cn_en_num_interval', {
//             target: app.$t('i18n_role_name'),
//             min,
//             max
//           })
//         }
//       }
//     ]
//   }
// }

/**
 * 欄位檢核：客製化名稱
 * @param customWord 你想要檢核的欄位名稱
 * @param max 最大字數
 */
// export const customName = (customWord = '', max = 30) => {
//   return {
//     validateFirst: true,
//     rules: [
//       {
//         required: true,
//         message: function() {
//           return app.$t('i18n_rule_required_fill', { field: customWord })
//         }
//       },
//       {
//         pattern: /^[\u4e00-\u9fa5A-Za-z0-9~!@#$%^&*()-_+{}|:"<>?[\]\\;',./\s]+$/,
//         message: function() {
//           return app.$t('i18n_rule_all_char_max', {
//             target: customWord,
//             max
//           })
//         }
//       },
//       {
//         max,
//         message: function() {
//           return app.$t('i18n_rule_all_char_max', {
//             target: customWord,
//             max
//           })
//         }
//       }
//     ]
//   }
// }

/**
 * 欄位檢核-帳號
 * 支援：
 * 1. 必填檢核
 * 2. 英數檢核
 * 3. 字數檢核，預設最大20/最小5
 * 不支援：
 * 1. 帳號是否已存在，需由 api 得知，自行處理
 */
// export const customAccount = (customWord = '', min = 5, max = 20) => {
//   customWord === '' && app.$t('i18n_account')
//   return {
//     rules: [
//       {
//         validator: (rule, value, cb) => {
//           let check = !/^[A-Za-z0-9]+$/.test(value)

//           if (!value)
//             return cb(app.$t('i18n_rule_required_fill', { field: customWord }))

//           if (value.length < min || value.length > max || check)
//             return cb(
//               app.$t('i18n_rule_alphanumeric_interval', {
//                 target: customWord,
//                 min: min,
//                 max: max
//               })
//             )
//           return cb()
//         }
//       }
//     ]
//   }
// }

/*
  欄位檢核-Email
  支援：
  1. 必填檢核
  2. 格式檢核
  3. 字數檢核，預設100
  不支援：
  1. 不支援重複Email，需由 api 得知，自行處理
  */
export const email = (max = 100) => {
  return {
    rules: [
      {
        required: false,
        message: function() {
          return app.$t('i18n_rule_required_fill', { field: 'E-mail' })
        }
      },
      {
        type: 'email',
        message: function() {
          return app.$t('i18n_rule_required_fill_correct', { field: 'E-mail' })
        }
      },
      {
        max,
        message: function() {
          return app.$t('i18n_rule_required_fill_correct', { field: 'E-mail' })
        }
      }
    ]
  }
}

/*
  欄位檢核-電話
  支援：
  1. 格式限制，限數字與「*」、「+」、「#」
  2. 字數檢核，預設50
  */
export const mobile = (max = 50) => {
  return {
    rules: [
      {
        pattern: /^((\*|\+|#)|[0-9])+$/,
        // 请填写正确的电话格式(可包含*,+,#)
        message: function() {
          return app.$t('i18n_rule_required_fill_correct', {
            field: app.$t('i18n_format_tel')
          })
        }
      },
      {
        max,
        message: function() {
          return app.$t('i18n_rule_required_fill_correct', {
            field: app.$t('i18n_format_tel')
          })
        }
      }
    ]
  }
}

export const otp = () => {
  return {
    rules: [
      {
        required: true,
        message: function() {
          return app.$t('i18n_input_otp')
        }
      },
      {
        pattern: new RegExp(/[0-9]/),
        message: function() {
          return app.$t('i18n_otp_verification')
        }
      },
      {
        min: 6,
        message: function() {
          return app.$t('i18n_otp_verification')
        }
      },
      {
        max: 6,
        message: function() {
          return app.$t('i18n_otp_verification')
        }
      }
    ]
  }
}

// 必填 rule
export const requiredRule = field => [
  {
    required: true,
    message: () => app.$t('i18n_rule_required_fill', { field })
  }
]

// IP rule
export const ipFormatRule = () => {
  return {
    validateFirst: true,
    rules: {
      pattern: /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/,
      message: () => app.$t('i18n_ip_rule'),
      trigger: 'blur'
    }
  }
}
